import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import 'firebase/compat/storage';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyB4sPIUWDMscRz2JRLF5Y_aLAooJA9EpoU",
    authDomain: "infy-mail-box.firebaseapp.com",
    projectId: "infy-mail-box",
    storageBucket: "infy-mail-box.appspot.com",
    messagingSenderId: "592407477724",
    appId: "1:592407477724:web:02559bfb0dc712e4f5e319",
    measurementId: "G-ERSE8QZMZ0"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
export const dataref = firebase.database();
export const storage = firebase.storage();
const auth = firebaseApp.auth();
const provider = new firebase.auth.GoogleAuthProvider();
export default firebase;
export { auth, provider };
export const firestore = firebase.firestore();
export const usersRef = firestore.collection('users');
export const emailsRef = firestore.collection('emails');
export const tasksRef = firestore.collection('tasks');
export const chatsRef = firestore.collection('chats');
export const chatRoomsRef = firestore.collection('chatRooms');
export const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp();